import _ from 'lodash';
import { enable as cooperativeCompany } from './modules/cooperative-company/index';
export function registerModules(context) {
    const modules = [
        cooperativeCompany
    ];
    _.each(modules, mod => {
        mod(context);
    });
}
